<template>
  <component
    :is="div ? 'div' : 'q-dialog'"
    v-model="shown"
  >
    <q-card
      v-if="orderForCollection"
      style="min-width: 50%;"
    >
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Collect Order
        </div>
        <q-space />
        <q-btn
          v-if="!div"
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>

      <q-card-section>
        <div
          v-if="$kiosk && allItemsForPastShowings"
          class="text-center q-pa-md"
        >
          <q-icon
            name="warning"
            color="secondary"
            size="48px"
          />
          <div class="text-h6 q-mt-md">
            {{ $t('kiosk.cannotPrintTicketForPastShowtime') }}
          </div>
        </div>
        <model-table
          v-else
          :collection="orderForCollection.orderItems"
          selection="multiple"
          :columns="[
            { field: 'id' },
            { field: 'type', component: OrderItemTypeCell },
            { field: 'state', component: OrderStateCell },
            { field: 'description', maxWidth: '250px' },
            { field: 'total', component: 'money' },
            { field: 'collectedAt' }
          ]"
          :cell-class="props => classesForRow(props.row)"
          :show-add="false"
          :show-edit="false"
          row-key="id"
          :initial-selection="selected"
          :filter-by-data-array="orderForCollection.collectableItemsForFutureShowings"
          @selected-input="selectedUpdate => selected = selectedUpdate"
        >
          <template #header-controls>
            <q-toggle
              v-if="showGroupTicketPrinting"
              v-model="groupTicket"
              label="Print as Group Ticket"
              icon="group"
              left-label
            />
          </template>
        </model-table>
      </q-card-section>
      <q-card-actions
        v-if="!$kiosk || !allItemsForPastShowings"
        class="row justify-center"
      >
        <q-btn
          class="col"
          size="xl"
          color="primary"
          :disable="validSelection.length === 0"
          :loading="collecting"
          @click="collect()"
        >
          Collect
        </q-btn>
      </q-card-actions>
    </q-card>
  </component>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import OrderItemTypeCell from 'src/modules/admin/order/components/OrderItemTypeCell'
import OrderStateCell from 'src/modules/admin/order/components/OrderStateCell'

export default {
  name: 'CollectionDialog',
  components: {
    ModelTable
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    order: {
      type: Object,
      required: false,
      default: null
    },
    div: {
      type: Boolean,
      required: false,
      default: false
    },
    refetch: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['order-collected', 'update:model-value'],
  data () {
    return {
      shown: false,
      selected: [],
      collecting: false,
      groupTicket: false,
      orderFromShow: null
    }
  },
  computed: {
    validSelection () {
      return _.filter(this.selected, { collectedAt: null })
    },
    registerType () {
      return this.currentRegisterClient?.registerStation?.registerType
    },
    showGroupTicketPrinting () {
      return this.registerType?.groupTicketPrintingEnabled && this.order.hasMultipleTicketsForShowing
    },
    orderForCollection () {
      return this.orderFromShow || this.order
    },
    allItemsForPastShowings () {
      if (!_.isEmpty(this.orderForCollection?.collectableItems)) {
        return false
      }
      return _.every(this.orderForCollection.collectableItems, item => {
        const showing = item.ticket?.showing
        return showing?.isPast
      })
    }
  },
  configuration: ['currentCircuit', 'currentSite'],
  context: ['currentRegisterClient'],
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)

      if (this.initialSelectedIds) {
        this.selected = [..._.filter(this.orderForCollection.collectableItems, orderItem => _.includes(this.initialSelectedIds, orderItem.id))]
      } else {
        this.selected = [...this.orderForCollection.collectableItems]
      }
      if (!this.shown) {
        this.orderFromShow = null
      }
    }
  },
  created () {
    _.extend(this, {
      OrderItemTypeCell,
      OrderStateCell
    })
  },
  methods: {
    show (order, initialSelectedIds = null) {
      this.orderFromShow = order
      this.initialSelectedIds = initialSelectedIds
      this.shown = true
    },
    classesForRow (orderItem) {
      if (orderItem.collectedAt === null) {
        return []
      } else {
        return ['tr-bg-grey-5', 'bg-grey-5']
      }
    },
    async collect () {
      this.collecting = true

      this.orderForCollection.groupTicket = this.groupTicket
      await this.orderForCollection.collect(_.map(this.validSelection, 'id'))
      this.refetch && await this.orderForCollection.fetch(true)
      this.collecting = false
      this.$emit('order-collected')
      this.shown = false
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.tr-bg-grey-5) {
  background: #BDBDBD;
}
</style>
